import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "agent-editor" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Button = _resolveComponent("Button")
  const _component_AgentOutput = _resolveComponent("AgentOutput")
  const _component_BuilderInputs = _resolveComponent("BuilderInputs")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString($data.editing_idx === undefined ? 'Add agent' : 'Edit agent'), 1 /* TEXT */),
        _createVNode(_component_Ellipsis, { class: "description" }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Configure a Test Agent for use by Test Skills")
          ])),
          _: 1 /* STABLE */
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        ($options.has_diff || $data.editing_idx !== undefined)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              tiny: "",
              onClick: $options.discard
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Discard")
              ])),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_Button, {
          tiny: "",
          primary: "",
          disabled: !$options.can_save,
          onClick: $options.submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($data.editing_idx === undefined ? 'Add' : 'Save'), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled", "onClick"])
      ])
    ]),
    _createVNode(_component_BuilderInputs, {
      ref: "fields",
      "vread-from": "valid",
      "onUpdate:valid": $event => (($data.valid) = $event),
      class: "fields",
      opts: $options.schema,
      gap: "1.2rem",
      propstore: $data.fields
    }, {
      output: _withCtx(() => [
        _createVNode(_component_AgentOutput, {
          modelValue: $data.fields.output,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.fields.output) = $event))
        }, null, 8 /* PROPS */, ["modelValue"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onUpdate:valid", "opts", "propstore"])
  ]))
}